// extracted by mini-css-extract-plugin
module.exports = {"listWrap":"listWrap--bPm7b","item":"item--2nYn0","describe":"describe--hvcBA","title":"title--3DpdH"};